import axiosInstance from './axiosInstance';

export const getAllCommissionProgress = () =>
    axiosInstance.get("/CommissionProgress/GetAllCommissionProgress");

export const getCommissionProgressByAgentId = (agentId) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressByAgentId?agentId=${agentId}`);

export const getCommissionProgressBySalesIdAgentId = (salesId, agentId) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressBySalesIdAgentId?salesId=${salesId}&agentId=${agentId}`);

export const updateCommissionProgress = (data) =>
    axiosInstance.put("/CommissionProgress/UpdateCommissionProgress", data);